import { useEffect, useRef } from 'react';
import { MovableManager } from './MovableManager';
export var useMovable = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.active, active = _c === void 0 ? true : _c, onStart = _b.onStart, onEnd = _b.onEnd, ref = _b.ref;
    var styleRef = useRef({ transform: 'translate3d(0, 0, 0)', transition: 'none' });
    var managerRef = useRef(new MovableManager(function (nextStyle) {
        styleRef.current = nextStyle;
    }, { onStart: onStart, onEnd: onEnd }));
    var rootRef = useRef(null);
    var targetRef = ref || rootRef;
    useEffect(function () {
        return function () {
            managerRef.current.stop();
        };
    }, []);
    return {
        control: {
            onMouseDown: function (e) {
                if (active && e.button === 0) {
                    managerRef.current.start({ x: e.pageX, y: e.pageY }, targetRef.current);
                    e.preventDefault();
                    e.stopPropagation();
                }
            },
            onMouseUp: function (e) {
                managerRef.current.stop();
                e.preventDefault();
                e.stopPropagation();
            }
        },
        target: {
            ref: targetRef,
            style: active ? styleRef.current : {}
        }
    };
};
//# sourceMappingURL=hooks.js.map